import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import MetaTags from 'react-meta-tags';
import MetaLoader from '../../../ui/MetaLoader';

const WP_BASE = `${process.env.REACT_APP_WP_BASE}`;
const getAbsUrl = href => `${WP_BASE}${href}`;

const getVolumeLabel = volumeInml => {
  switch (volumeInml) {
    case 750:
      return '750ml';
    case 1500:
      return '1.5L';
    case 4500:
      return '6 Btl';
    case 3000:
      return '3L';
  }
};

const getLabel = ({ volumeInml, attribute }) => {
  const { attributeText } = attribute || {};
  if (attributeText) return attributeText;;
  if (volumeInml) return getVolumeLabel(volumeInml);
};

const ClubPriceTeaser = ({ units, productSkuId, label }) => {
  const unit = (units || [])
    .find(({ pricingProductSkuId }) => pricingProductSkuId === productSkuId);

  if (!unit) return false;

  const { unitPrice, kitMarkdown } = unit || {};

  return (
    <span>
      {numeral(unitPrice - (kitMarkdown || 0)).format('$0,0.00')}
      {' '}
      {label}
      <br />
    </span>
  );
};

class Product extends Component {
  constructor(props) {
    super(props);
    const {
      sellableUnits
    } = props;
    const { productKitId } = (sellableUnits || [])[0] || {};
    this.state = {
      selected: productKitId,
      qty: 1,
      invalid: 0
    };
  }
  render() {
    const {
      hasClubPrices,
      Slug,
      Name,
      sellableUnits,
      clubUnits,
      LongDescription,
      ShortDescription,
      IsClubOnly,
      onAddToCart,
      images,
      user,
      MetaTitle,
      MetaDescription,
      soldOut,
      RibbonText,
      StoryDescription,
      StoryHeadline,
      isMemberShipmentOnly,
      isComingSoon,
      productTypeId
    } = this.props;

    const {
      detailImage
    } = images || {};

    const { href: imgHref } = detailImage || {};

    const productSizes = (sellableUnits || []).map(({
      productKitId,
      volumeInml,
      soldOut,
      attribute
    }) => ({
      productKitId,
      soldOut,
      label: getLabel({ volumeInml, attribute })
    }));

    const { selected, qty, invalid } = this.state;

    const handleProductSizeChange = e => {
      const { value } = e.target;
      this.setState({ selected: parseInt(value) });
    };

    const handleQtyChange = e => {
      const { value } = e.target;
      this.setState({ qty: parseInt(value) || '' });
    };

    const activeUnit = (sellableUnits || [])
      .find(({ productKitId }) => productKitId === selected);

    const {
      unitPrice,
      kitMarkdown,
      productSkuId,
      sku,
      soldOut: kitSoldOut,
      cartLimit: maxQuantity
    } = activeUnit || {};

    const handleAddToCart = () => {
      // first validate number
      if (isNaN(qty)) {
        this.setState({ invalid: 1 });
        return;
      }
      if (qty <= 0) {
        this.setState({ invalid: 2 });
        return;
      }
      if (qty > maxQuantity) {
        this.setState({ invalid: 3 });
        return;
      }
      //if its okay reset invalid and add to cart
      this.setState({ invalid: 0 });
      onAddToCart({ payload: { kitId: selected, qty } });
    };

    const { userId, ClubMember } = user || {};

    const hasUser = !!userId;

    const { IsDisabled } = ClubMember || {};

    const isActiveClubMember = hasUser && !!ClubMember && !IsDisabled;

    const {
      velmaUnits,
      duncanUnits,
      foundersUnits
    } = clubUnits || {};

    const isProduct = productTypeId === 1; // 1 - wine

    return (
      <section className="pdp-top">
        <MetaLoader title={MetaTitle || Name} />
        <MetaTags>
          <title>{MetaTitle || Name}</title>
          <meta name="description" content={MetaDescription} />
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content={`${MetaTitle || Name}`} />
          <meta property="og:type" content="article" />
          <meta property="og:description" content={MetaDescription} />
          <meta property="og:image" content={imgHref} />
          <meta
            property="og:url"
            content={`https://twomey.com/shop/p/${Slug}/`}
          />
          <link rel="canonical" href={`https://twomey.com/shop/p/${Slug}/`} />
        </MetaTags>
        <div className="row">
          <div
            className={
              isProduct
                ? 'col-md-4 order-md-2 offset-md-2'
                : 'col-md-5 order-md-2 offset-md-1'
            }
          >
            <img src={imgHref} alt={Name} />
          </div>
          <div className="col-md-4 offset-md-1">

            {RibbonText && <p className="special-message">{RibbonText}</p>}

            <h1 className="shop-large">{Name}</h1>

            {!isComingSoon &&
              (!IsClubOnly || (hasUser && isActiveClubMember)) &&
              <h2 className="price">
                {numeral(unitPrice-(kitMarkdown || 0)).format('$0,0.00')}{' '}<em
                  dangerouslySetInnerHTML={{
                    __html: ShortDescription || ''
                  }}
                />
              </h2>}

            {isComingSoon &&
              <h2 className="price">
                <em
                  dangerouslySetInnerHTML={{
                    __html: ShortDescription || ''
                  }}
                />
              </h2>}

            {!isComingSoon &&
              (!hasUser || !isActiveClubMember) &&
              <div className="club-prices">
                <ClubPriceTeaser
                  units={velmaUnits}
                  productSkuId={productSkuId}
                  label="Explorer Price"
                />
                <ClubPriceTeaser
                  units={duncanUnits}
                  productSkuId={productSkuId}
                  label="Collector Price"
                />
                <ClubPriceTeaser
                  units={foundersUnits}
                  productSkuId={productSkuId}
                  label="Founder Price"
                />
                {!soldOut &&
                  !hasUser &&
                  !IsClubOnly &&
                  !isMemberShipmentOnly &&
                  hasClubPrices &&
                  <Link to="/account/login" className="caps">
                    Log in For Member Pricing
                  </Link>}
                {!hasUser &&
                  IsClubOnly &&
                  <p className="club-prices">
                    {!isMemberShipmentOnly &&
                      <Link to="/account/login" className="caps">
                        Members only. Log in to order
                      </Link>}
                    <a href={getAbsUrl('/wine-club/')}>
                      <em>Learn About Membership</em>
                    </a>
                  </p>}
                {hasUser &&
                  IsClubOnly &&
                  !isActiveClubMember &&
                  <p className="club-prices">
                    {!isMemberShipmentOnly &&
                      <Link to="/account/login" className="caps">
                        Members only. Log in to order
                      </Link>}
                    <a href={getAbsUrl('/wine-club/')}>
                      <em>Learn About Membership</em>
                    </a>
                  </p>}
              </div>}

            {soldOut &&
              <form className="add-to-cart">
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  disabled
                >
                  Sold Out
                </button>
              </form>}

            {isMemberShipmentOnly &&
              <form className="add-to-cart">
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  disabled
                >
                  Member Shipment Only
                </button>
              </form>}

            {isComingSoon &&
              <form className="add-to-cart">
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  disabled
                >
                  Coming Soon
                </button>
              </form>}

            {!soldOut &&
              !isComingSoon &&
              !isMemberShipmentOnly &&
              (!IsClubOnly || isActiveClubMember) &&
              <form className="add-to-cart">
                <div className="form-row">
                  <div className="col-6">
                    <div className="form-group">
                      <label className="sr-only">Select Quantity</label>
                      <input
                        name="quantity"
                        className="form-control"
                        type="number"
                        min="1"
                        max={maxQuantity}
                        onChange={handleQtyChange}
                        placeholder="Qty"
                        value={qty}
                      />
                    </div>
                  </div>
                  {(isProduct || (!isProduct && productSizes.length > 1)) &&
                    <div className="col-6">
                      <div className="form-group">
                        <label className="sr-only">Select Size</label>
                        <select
                          className="form-control"
                          value={selected}
                          onChange={handleProductSizeChange}
                        >
                          {(productSizes || []).map(({
                            productKitId,
                            label,
                            soldOut
                          }, index) => (
                            <option
                              value={productKitId}
                              key={index}
                              disabled={soldOut}
                            >
                              {label}{soldOut ? ' (SOLD OUT)' : ''}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>}
                </div>
                <div className="text-center">
                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    onClick={handleAddToCart}
                    disabled={kitSoldOut}
                  >
                    Add to Cart
                  </button>
                </div>
                <div>
                  <br />
                  {invalid === 1 &&
                    <span style={{ color: '#AF272F' }}>
                      Invalid quantity: entry must be a number
                    </span>}
                  {invalid === 2 &&
                    <span style={{ color: '#AF272F' }}>
                      Invalid quantity: entry must be a number greater than 0
                    </span>}
                  {invalid === 3 &&
                    <span style={{ color: '#AF272F' }}>
                      Invalid quantity: maximum of {maxQuantity}
                    </span>}
                </div>
              </form>}

            <div
              className="product-description"
              dangerouslySetInnerHTML={{
                __html: LongDescription || ''
              }}
            />

          </div>
        </div>
        <div itemProp="offers" itemScope itemType="http://schema.org/Offer">
          <meta itemProp="url" content={`https://twomey.com/shop/p/${Slug}/`} />
          <meta itemProp="availability" content="http://schema.org/InStock" />
          <meta
            itemProp="itemCondition"
            itemType="http://schema.org/OfferItemCondition"
            content="http://schema.org/NewCondition"
          />
          <meta itemProp="priceCurrency" content="USD" />
          <meta
            itemProp="price"
            content={numeral(unitPrice).format('$0,0.00') || ''}
          />
          <meta itemProp="sku" content={sku || ''} />
        </div>
      </section>
    );
  }
}

export default Product;
